import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email.trim(), password);
    setBusy(false);
    if (r.ok) {
      toast.success("Welcome back to Manodayam");
      const role = r?.user?.role;
      if (role === "clinical_specialist" || role === "adjunctive_specialist") {
        nav("/specialist");
      } else if (role === "platform_admin") {
        nav("/admin");
      } else {
        nav("/home");
      }
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen bg-[color:var(--mano-bg)] flex items-center justify-center px-5 py-8">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[color:var(--mano-border)] p-8">
        <Link to="/" data-testid="login-back-home" className="uppercase-label">← Home</Link>
        <h1 className="font-display text-3xl mt-4">Welcome back</h1>
        <p className="text-[color:var(--mano-ink-soft)] mt-2 text-sm">
          Sign in to continue your care journey.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="uppercase-label">Email</span>
            <input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full h-12 px-4 rounded-xl border border-[color:var(--mano-border)] bg-[color:var(--mano-bg)] focus:outline-none focus:border-[color:var(--mano-primary)]"
              placeholder="you@example.com"
            />
          </label>
          <label className="block">
            <span className="uppercase-label">Password</span>
            <input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full h-12 px-4 rounded-xl border border-[color:var(--mano-border)] bg-[color:var(--mano-bg)] focus:outline-none focus:border-[color:var(--mano-primary)]"
              placeholder="••••••••"
            />
          </label>
          <button
            data-testid="login-submit-btn"
            disabled={busy}
            className="w-full h-12 rounded-full bg-[color:var(--mano-primary)] hover:bg-[color:var(--mano-primary-hover)] text-white font-semibold transition-colors disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <div className="text-sm text-center mt-6 text-[color:var(--mano-ink-soft)]">
          New here?{" "}
          <Link to="/register" data-testid="login-signup-link" className="text-[color:var(--mano-primary)] font-semibold">
            Create an account
          </Link>
        </div>
        <div className="text-xs text-center mt-4 text-[color:var(--mano-ink-soft)]">
          Demo: <span className="font-mono">admin@manodayam.com / Admin@123</span> · <span className="font-mono">user@manodayam.com / User@123</span>
        </div>
      </div>
    </div>
  );
}
